import installationInstructions from './installationInstructions';

const coriContent = {
  installationInstructions
}

export { coriContent };